import ArticleLayout from '@/pages/article/components/ArticleLayout';
import { allArticles } from '@/mocks/articleContents';

export default function KakobuySpreadsheetGuide() {
  return <ArticleLayout content={allArticles[0]} />;
}